import { useFormikContext } from 'formik'

import { EMPTY_LIST } from '../../../../../../constants/common'
import { isAsyncTaskSuccessStatus, sleep } from '../../../../../../utils/async'
import {
  testEmailGoogleTemplateVariables,
  testEmailTextTemplateVariables,
  testEmailVariablesStatus,
} from '../../../../Email.api'
import { EMAIL_CREATION_FORM_TEST_VARIABLES_STATUS_INTERVAL } from '../../../EmailCreationForm.constants'
import { EmailSelectTemplateToTestOptionValue } from '../../../EmailSelectTemplateToTestVariablesModal'

import { EXTERNAL_VARIABLES_API_KEY } from './useTestVariablesReports.constants'
import {
  getParamsTestGoogleTemplate,
  getParamsTestTextTemplate,
  isTestVariablesStatusInProgress,
  parseReport,
} from './useTestVariablesReports.utils'

export function useTestVariablesReports() {
  const { values } = useFormikContext()

  function getVariablesFinalStatus(eventId) {
    return eventId
      ? testEmailVariablesStatus(eventId).then(({ data }) =>
          isTestVariablesStatusInProgress(data?.status)
            ? sleep(EMAIL_CREATION_FORM_TEST_VARIABLES_STATUS_INTERVAL).then(
                () => getVariablesFinalStatus(eventId)
              )
            : data
        )
      : Promise.reject(new Error('Variables test has no event id'))
  }

  function getVariablesReport({ eventId, externalVariablesKey, template }) {
    return getVariablesFinalStatus(eventId).then(finalStatus =>
      isAsyncTaskSuccessStatus(finalStatus)
        ? parseReport({
            externalKey: externalVariablesKey,
            result: finalStatus.result,
            template,
          })
        : Promise.reject(new Error('Variables test did not succeed'))
    )
  }

  function getGoogleTemplateReport(docTemplate) {
    return testEmailGoogleTemplateVariables(
      getParamsTestGoogleTemplate(values, docTemplate)
    ).then(({ data }) =>
      getVariablesReport({
        eventId: data?.event_id,
        externalVariablesKey:
          EXTERNAL_VARIABLES_API_KEY[
            EmailSelectTemplateToTestOptionValue.googleTemplate
          ],
        template: docTemplate,
      })
    )
  }

  function getGoogleTemplatesReports(docTemplates) {
    return docTemplates.reduce(
      (reportsPromise, docTemplate) =>
        reportsPromise.then(reports =>
          getGoogleTemplateReport(docTemplate)
            .catch(() => null)
            .then(report => [...reports, report])
        ),
      Promise.resolve(EMPTY_LIST)
    )
  }

  function getTextTemplateReport(textTemplate) {
    return testEmailTextTemplateVariables(
      textTemplate.id,
      getParamsTestTextTemplate(values, textTemplate)
    ).then(({ data }) =>
      getVariablesReport({
        eventId: data?.event_id,
        externalVariablesKey:
          EXTERNAL_VARIABLES_API_KEY[
            EmailSelectTemplateToTestOptionValue.textTemplate
          ],
        template: textTemplate,
      })
    )
  }

  return {
    getGoogleTemplatesReports,
    getTextTemplateReport,
  }
}
